/**
 * Legge TUTTE le righe di una query Supabase a pagine (PostgREST taglia in silenzio a 1.000 righe).
 * Puro rispetto al client: riceve una funzione che, dati (from, to), restituisce la query con `.range(from, to)`
 * (e un ordine stabile, es. `.order('id')`, altrimenti le pagine possono ripetere o saltare righe).
 * Testato in __tests__/fetchAllPages.test.ts.
 */

export const FETCH_PAGE_SIZE = 1000;
/** Limite di sicurezza: oltre queste pagine ci si ferma (100 pagine = 100.000 righe) invece di girare all'infinito. */
export const FETCH_MAX_PAGES = 100;

interface PageResult<T> { data: T[] | null; error: any }

export interface FetchAllResult<T> {
  /** Tutte le righe lette; null se una pagina e' andata in errore (come fa Supabase). */
  data: T[] | null;
  error: any;
  /** true se ci si e' fermati al limite di pagine con altre righe ancora da leggere. */
  truncated: boolean;
}

export async function fetchAllPages<T = any>(
  buildQuery: (from: number, to: number) => PromiseLike<PageResult<T>>,
  opts: { pageSize?: number; maxPages?: number } = {},
): Promise<FetchAllResult<T>> {
  const pageSize = opts.pageSize ?? FETCH_PAGE_SIZE;
  const maxPages = opts.maxPages ?? FETCH_MAX_PAGES;
  const rows: T[] = [];
  for (let page = 0; page < maxPages; page++) {
    const from = page * pageSize;
    const { data, error } = await buildQuery(from, from + pageSize - 1);
    // Errore a meta': niente dati parziali presentati come completi
    if (error) return { data: null, error, truncated: false };
    const chunk = data || [];
    rows.push(...chunk);
    // Pagina non piena = ultima pagina
    if (chunk.length < pageSize) return { data: rows, error: null, truncated: false };
  }
  console.warn(`[fetchAllPages] fermato al limite di ${maxPages} pagine: risultati incompleti`);
  return { data: rows, error: null, truncated: true };
}
